import React from 'react';
import styled from '@emotion/styled';
import { Radio } from 'semantic-ui-react';
import { settings } from 'cluster';
import { optionCSS } from 'react-select/src/components/Option';

interface IProps {
  option: SettingOption;
  selectedValue: string | number | boolean;
  setCompanySettings: any;
  settingName: string;
  label: string;
  index: number
}

export default function Option(props: IProps) {
  return (
    <div style={{ marginLeft: props.index > 0 ? 16 : 0 }}>
      <Radio
        label={props.option.text}
        checked={props.selectedValue === props.option.id}
        onChange={e => {
          props.setCompanySettings(props.settingName, props.option.id);
        }}
      />
    </div>
  );
}